import UUID from "../Utilities/Generic/UUID";
import DeviceIdentifiers from "./device-identifiers";

export const generateInstanceID = (): string => {
    console.log("Generating new instance ID");
    const identifiers = DeviceIdentifiers;

    return `${
        identifiers[Math.floor(Math.random() * identifiers.length)]
    }-${UUID.generate().slice(0, 8)}`;
};
